import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <main>
        <Header />
        <Footer />
      </main>
    </div>
  );
}

export default App;
